// src/components/CourseLessonSelector.js
import React from "react";
import { Stack, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export function CourseLessonSelector({ editor }) {
  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2, width: "100%" }}>
      {/* Course */}
      <FormControl sx={{ flex: 1 }} size="small">
        <InputLabel id="course-label">Course</InputLabel>
        <Select
          labelId="course-label"
          value={editor.selectedCourse || ""}
          label="Course"
          onChange={(e) => editor.setSelectedCourse(e.target.value)}
          size="small"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          <MenuItem value="">
            <em>-- choose --</em>
          </MenuItem>
          {editor.courses.map(({ id, subject }) => (
            <MenuItem
              key={id}
              value={id}
              title={subject}
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {subject}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Lesson */}
      <FormControl sx={{ flex: 1 }} size="small">
        <InputLabel id="lesson-label">Lesson</InputLabel>
        <Select
          labelId="lesson-label"
          value={editor.selectedLesson || ""}
          label="Lesson"
          onChange={(e) => editor.setSelectedLesson(e.target.value)}
          disabled={!editor.selectedCourse}
          size="small"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          <MenuItem value="">
            <em>-- choose --</em>
          </MenuItem>
          {editor.lessons.map(({ id, title }) => (
            <MenuItem
              key={id}
              value={id}
              title={title}
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
